export const MAX_API_RETRIES = 2;

export const ORDER_WEIGHT = {
  Large: 15,
  Medium: 10,
  Small: 5,
};
